export default __webpack_public_path__ + "static/media/riale_footer.06a29c1b.png";